import { ReactNode } from "react";
import { Flex, Typography } from "antd";

import styles from "./info.module.css";

interface IProps {
  title: string | ReactNode;
  text: string | ReactNode;
  id?: string;
}

export const WrappedItemInfo = (props: IProps) => {
  const { title, text, id } = props;
  return (
    <Flex vertical className={styles.wrappedItemBox} id={id}>
      <Typography.Text className={styles.wrappedItemBoxLabel}>{title}</Typography.Text>
      <Flex align="center" gap="4px">
        <Typography.Text className="text-middle">{text}</Typography.Text>
      </Flex>
    </Flex>
  );
};
